module.exports = __webpack_public_path__ + "static/media/execute_examTypes.8aae4da9.png";